/* eslint-disable */
import { useState } from "react";
import { T, useTheme } from "../../tokens";
import { SPACING, TYPO } from "../../shared/layoutTokens";

const COLORS = [
  { n: "Brand Primary",   h: "#5e4ce2",                  t: "--ziniz-brand-primary",            w: "4.5:1 on white" },
  { n: "Brand Hover",     h: "#5046d4",                  t: "--ziniz-primary-action-hover",     w: "5.2:1" },
  { n: "Brand Soft",      h: "rgba(94,76,226,0.12)",     t: "--ziniz-outline-action-hover-bg",  w: "bg only" },
  { n: "Tech Cyan",       h: "#06b6d4",                  t: "--ziniz-tech-cyan",                w: "use on dark" },
  { n: "Tech Teal",       h: "#14b8a6",                  t: "--ziniz-tech-teal",                w: "3.8:1" },
  { n: "Edge Violet",     h: "#7c3aed",                  t: "--ziniz-edge-violet",              w: "5.1:1" },
  { n: "Signal Amber",    h: "#f59e0b",                  t: "--ziniz-signal-amber",             w: "use on dark" },
  { n: "Dark Canvas",     h: "#0a0d12",                  t: "--zh-d-canvas",                    w: "base" },
  { n: "Dark Surface",    h: "#111318",                  t: "--zh-d-surface",                   w: "cards" },
  { n: "TextSec Fixed",   h: "#b0bec5",                  t: "--zh-d-text-secondary",            w: "4.6:1 ✓ AA" },
  { n: "Success",         h: "#22c55e",                  t: "--zh-success",                     w: "dark bg only" },
  { n: "Danger",          h: "#ef4444",                  t: "--zh-danger",                      w: "4.8:1" },
];

export default function BrandBook({ dark: darkProp }) {
  const [localDark, setLocalDark] = useState(false);
  const dark = typeof darkProp === "boolean" ? darkProp : localDark;
  const th = useTheme(dark);
  const standalone = typeof darkProp !== "boolean";

  const content = (
    <div style={{ maxWidth: 860 }}>
      <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 6, color: th.text }}>Brand Tokens</div>
      <div style={{ color: th.textSec, fontSize: 12, marginBottom: 20 }}>
        ZiniHub design system sourced from ziniz official index.css.
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(180px,1fr))",
          gap: 8,
          marginBottom: 24,
        }}
      >
        {COLORS.map((c) => (
          <div
            key={c.n}
            style={{
              background: th.surface,
              border: `1px solid ${th.border}`,
              borderRadius: T.rlg,
              overflow: "hidden",
            }}
          >
            <div style={{ height: 48, background: c.h, position: "relative" }}>
              {c.h.includes("rgba") && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "repeating-linear-gradient(45deg,rgba(128,128,128,0.1) 0,rgba(128,128,128,0.1) 5px,transparent 5px,transparent 10px)",
                  }}
                />
              )}
            </div>
            <div style={{ padding: "8px 10px" }}>
              <div style={{ fontWeight: 500, fontSize: 11, color: th.text }}>{c.n}</div>
              <div style={{ fontFamily: "monospace", fontSize: 9, color: th.textSec, marginTop: 1 }}>
                {c.h.startsWith("#") ? c.h.toUpperCase() : c.h}
              </div>
              <div style={{ fontFamily: "monospace", fontSize: 9, color: T.brand, marginTop: 1 }}>{c.t}</div>
              <div style={{ fontSize: 9, color: th.textMuted, marginTop: 3 }}>{c.w}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10, color: th.text }}>Status Badges</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginBottom: 20 }}>
        {[
          ["Placed",     T.amber,         "rgba(245,158,11,0.15)"],
          ["Confirmed",  "#60a5fa",       "rgba(59,130,246,0.15)"],
          ["Cancelled",  T.red,           "rgba(239,68,68,0.15)"],
          ["Delivered",  T.green,         "rgba(34,197,94,0.15)"],
          ["Processing", T.brand,         T.brandSoft],
          ["Live",       T.green,         "rgba(34,197,94,0.15)"],
          ["Draft",      th.textMuted,    "rgba(128,128,128,0.12)"],
          ["Public",     T.green,         "rgba(34,197,94,0.15)"],
          ["Private",    T.amber,         "rgba(245,158,11,0.15)"],
          ["Open",       T.green,         "rgba(34,197,94,0.15)"],
          ["Closed",     T.red,           "rgba(239,68,68,0.15)"],
        ].map(([l, color, bg]) => (
          <span
            key={l}
            style={{
              background: bg,
              color,
              borderRadius: 5,
              padding: "4px 9px",
              fontSize: 11,
              fontWeight: 500,
              border: `1px solid ${color}22`,
            }}
          >
            {l}
          </span>
        ))}
      </div>

      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10, color: th.text }}>New Indicator Badges</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 7 }}>
        {[
          ["🚚 Delivery",    T.cyan,  "rgba(6,182,212,0.15)"],
          ["🏪 Self Pickup", T.amber, "rgba(245,158,11,0.15)"],
          ["💳 Gateway",     T.brand, T.brandSoft],
          ["🤝 Self-managed",T.teal,  T.tealSoft],
          ["🛍️ Product",     T.brand, T.brandSoft],
          ["🔧 Service",     T.teal,  T.tealSoft],
          ["7-day returns",  T.cyan,  "rgba(6,182,212,0.1)"],
        ].map(([l, color, bg]) => (
          <span
            key={l}
            style={{
              background: bg,
              color,
              borderRadius: 5,
              padding: "4px 9px",
              fontSize: 11,
              fontWeight: 500,
              border: `1px solid ${color}22`,
            }}
          >
            {l}
          </span>
        ))}
      </div>

      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10, marginTop: 28, color: th.text }}>Typography</div>
      <div style={{ color: th.textSec, fontSize: 12, marginBottom: 14 }}>
        DM Sans for UI copy; JetBrains Mono for paths and tokens. Max 5 distinct sizes per screen.
      </div>
      <div style={{ background: th.surface, border: `1px solid ${th.border}`, borderRadius: T.rlg, overflow: "hidden", marginBottom: 24 }}>
        {[
          ["Hero", `${TYPO.hero.fontSize}px / ${TYPO.hero.fontWeight}`, "Landing headlines only"],
          ["Page title", `${TYPO.pageTitle.fontSize}px / ${TYPO.pageTitle.fontWeight}`, "Screen H1"],
          ["Section title", `${TYPO.sectionTitle.fontSize}px / ${TYPO.sectionTitle.fontWeight}`, "Card groups, panels"],
          ["Card title", `${TYPO.cardTitle.fontSize}px / ${TYPO.cardTitle.fontWeight}`, "List rows, compact headings"],
          ["Body", `${TYPO.body.fontSize}px / ${TYPO.body.fontWeight}`, "Default copy"],
          ["Caption", `${TYPO.caption.fontSize}px / ${TYPO.caption.fontWeight}`, "Meta, badges, hints"],
        ].map(([role, size, note], index, arr) => (
          <div
            key={role}
            style={{
              display: "grid",
              gridTemplateColumns: "120px 100px 1fr",
              padding: "8px 14px",
              borderBottom: index < arr.length - 1 ? `1px solid ${th.border}` : "none",
              fontSize: 11,
            }}
          >
            <div style={{ fontWeight: 500, color: th.text }}>{role}</div>
            <div style={{ fontFamily: "monospace", color: T.cyan }}>{size}</div>
            <div style={{ color: th.textMuted }}>{note}</div>
          </div>
        ))}
      </div>

      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10, color: th.text }}>Spacing scale</div>
      <div style={{ color: th.textSec, fontSize: 12, marginBottom: 14 }}>
        Use only values from the canonical scale — multiples of 4px. Page padding: desktop 16–20px, mobile 10–12px.
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 24 }}>
        {SPACING.map((space) => (
          <div
            key={space}
            style={{
              background: th.surface,
              border: `1px solid ${th.border}`,
              borderRadius: T.rmd,
              padding: "8px 12px",
              minWidth: 72,
              textAlign: "center",
            }}
          >
            <div style={{ fontFamily: "monospace", fontSize: 12, fontWeight: 600, color: T.brand }}>{space}px</div>
            <div style={{ height: space, background: T.brandSoft, borderRadius: 2, marginTop: 6, maxWidth: 48, margin: "6px auto 0" }} />
          </div>
        ))}
      </div>

      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10, color: th.text }}>Motion</div>
      <div style={{ background: th.surface, border: `1px solid ${th.border}`, borderRadius: T.rlg, overflow: "hidden", marginBottom: 24 }}>
        {[
          ["Fast", T.fast, "Hover, micro-interactions"],
          ["Mid", T.mid, "Tabs, toggles, sidebar collapse"],
          ["Slow", T.slow, "Page transitions, modals"],
          ["Ease", T.ease, "Default cubic-bezier"],
          ["Spring", T.spring, "Playful emphasis (sparingly)"],
        ].map(([label, value, note], index, arr) => (
          <div
            key={label}
            style={{
              display: "grid",
              gridTemplateColumns: "80px 1fr 1.2fr",
              padding: "8px 14px",
              borderBottom: index < arr.length - 1 ? `1px solid ${th.border}` : "none",
              fontSize: 11,
            }}
          >
            <div style={{ fontWeight: 600, color: th.text }}>{label}</div>
            <div style={{ fontFamily: "monospace", color: T.cyan }}>{value}</div>
            <p style={{ color: th.textMuted, margin: 0 }}>{note}</p>
          </div>
        ))}
      </div>
    </div>
  );

  if (!standalone) return content;

  return (
    <div style={{ background: th.bg, color: th.text, minHeight: "100vh", padding: 24, transition: th.tr }}>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <button
          onClick={() => setLocalDark((d) => !d)}
          style={{
            background: dark ? T.brandSoft : th.muted,
            border: `1px solid ${dark ? T.brandBorder : th.border}`,
            borderRadius: 16,
            padding: "4px 10px",
            cursor: "pointer",
            color: dark ? T.brand : th.textSec,
            fontSize: 11,
            fontWeight: 500,
            transition: th.tr,
          }}
        >
          {dark ? "🌙" : "☀️"}
        </button>
      </div>
      {content}
    </div>
  );
}
